import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Pagination } from '@mui/material'
import Visible from './Visible';
import { isInteger } from 'lodash';

const PaginationComponent = (props) => {
    // -- props --//
    const {
        className,
        option,
        onChange,
        page = 1,
        totalCount,
        pageLength,
        onSelect,
    } = props;

    const [numericList, setNumericList] = useState([]);

    const handleListCountChange = (event) => {
        onSelect(event.target.value);
    };

    useEffect(() => {
        const list =
            option?.list_count_elements
                .map((x) => Number(x))
                .filter((x) => x && isInteger(Number(x))) ?? [];
        list.sort((a, b) => a - b);
        setNumericList(list);
    }, [option]);

    // -- render --//
    return (
        <>
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                }}
            >
                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                    <Visible visible={option.list_count_enable && numericList.length > 0}>
                        {/*<p>페이지당 항목 수</p>*/}

                        <select
                            className={className}
                            value={pageLength}
                            onChange={handleListCountChange}
                            style={{
                                // width: 'fit-content',
                                height: 32,
                                minWidth : 'fit-content',
                                width : 50,
                                padding: 5,
                                display: 'flex',
                                alignItems: 'center',
                                borderRadius: 5,
                                border: '1px solid #CDCDD1',
                                fontSize: 12,
                                cursor: 'pointer',
                            }}
                        >
                            {numericList &&
                                numericList
                                    .filter((option) => option >= 1 && option < 101) // 1~100의 정수만 출력
                                    .map((option) => (
                                        <option key={option} value={option}>
                                            {option}
                                        </option>
                                    ))}
                        </select>
                    </Visible>

                    <Pagination
                        className="paginationTest"
                        count={Math.ceil(totalCount / pageLength)}
                        page={page}
                        onChange={onChange}
                        shape="rounded"
                        siblingCount={2}
                    />
                </div>

                <p
                    style={{
                        display: 'flex',
                    }}
                >
                    전체 {(totalCount || 0).toLocaleString()} 항목
                </p>
            </div>
        </>
    );
};

PaginationComponent.prototype = {
    disable: PropTypes.bool.isRequired,
    className: PropTypes.string,
    placeholder: PropTypes.string,
    type: PropTypes.string,
    value: PropTypes.number,
    onChange: PropTypes.func,
    onChangeCount: PropTypes.func,
    style: PropTypes.object,
};

export default PaginationComponent;
